/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { RootState } from '../../../../../store/root.reducers';
import { ButtonProps } from './ButtonProps';
import { ImageLoader } from '../../../../ImageLoader';
import { ImageLoaderTypes } from '../../../../ImageLoader/ImageLoaderTypes';

import './Button.scss';

const Button: FunctionComponent<ButtonProps> = (props): JSX.Element => {
    const { text, isFocused, displayValue }: ButtonProps = props;
    const { isOverlayGhostHighlightActive } = useSelector(
        (state: RootState) => state.overlayHighlight,
    );

    let optionButtonClasses = 'options-button ';
    if (isOverlayGhostHighlightActive && isFocused) {
        optionButtonClasses += ' highlight-stroke ghost-overlay';
    } else if (isFocused) {
        optionButtonClasses += ' highlight-stroke';
    }

    return (
        <div className={optionButtonClasses}>
            {text}
            {/* TODO: handle displayValue of type text, currently no usecase */}
            {displayValue?.type === 'image' && displayValue.value?.length ? (
                <div className="options-button-icons">
                    {displayValue.value.map((src, index) => (
                        <ImageLoader
                            src={src}
                            key={index}
                            imageType={ImageLoaderTypes.OPTION_BUTTON_ICON}
                        />
                    ))}
                </div>
            ) : null}
        </div>
    );
};

Button.propTypes = {
    id: PropTypes.number,
    text: PropTypes.string.isRequired,
    isFocused: PropTypes.bool.isRequired,
    isSelectOptionButton: PropTypes.bool,
    displayValue: PropTypes.any,
};
export default Button;
